'use client';
import { FC } from 'react';

import { CatIconNotifications } from '@blocks-react/components/Icons/Notifications';
import { CatBadge } from '@blocks-react/components/Badge';
import { HeaderNavItem } from '../header-nav-item/HeaderNavItem';
import { Conditional } from '../../common';

import { HeaderNotificationProps } from './types';

export const HeaderNotification: FC<HeaderNotificationProps> = ({
  action,
  handleDrawerProps,
  hasNotifications = false,
  id,
  isCurrent,
  title,
  ariaLabel
}) => (
  <HeaderNavItem
    data-testid="cat-header-notification-icon"
    id={id}
    onClick={action}
    aria-label={ariaLabel}
    isCurrent={isCurrent}
    title={title}
    {...handleDrawerProps}
    role="menu"
  >
    <span className="m-0" aria-label={ariaLabel}>
      <Conditional test={hasNotifications}>
        <CatBadge
          isDot
          position="top-right"
          variant="brand"
          data-testid="cat-header-notifications-indicator"
        />
      </Conditional>
      <div className=" d-md-none">
        <CatIconNotifications size="lg" />
      </div>
      <div className="d-none d-md-block d-lg-none">
        <CatIconNotifications size="lg" />
      </div>
      <div className=" d-none d-lg-block">
        <CatIconNotifications />
      </div>
    </span>
  </HeaderNavItem>
);
